<form
  [formGroup]="shipmentForm"
  (ngSubmit)="onSubmit()"
  class="pd-30 h100"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="30px"
>
  <h3 class="rm-margin" fxFlexAlign="center">
    {{ "SELECT_SHIPMENT_METHOD" | translate }}
  </h3>

  <mat-radio-group
    #shipment
    formControlName="shipment"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="20px"
  >
    <mat-radio-button value="PICKUP" [checked]="true">
      <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="10px">
        <span>{{ "PICK_UP_FROM_LOCATION" | translate }}</span>
        <div fxFlex></div>
        <mat-icon svgIcon="ic-location"></mat-icon>
      </div>
    </mat-radio-button>

    <mat-radio-button value="SHIPMENT">
      <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="10px">
        <span>{{ "RECEIVE_BY_MAIL" | translate }}</span>
        <div fxFlex></div>
        <mat-icon svgIcon="ic-cargo"></mat-icon>
      </div>
    </mat-radio-button>

    <mat-radio-button
      value="VAULT"
      *ngIf="(checkoutService.selectedPaymentRequest | async).type !== 'vault'"
    >
      <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="10px">
        <span>{{ "IN_THE_VAULT" | translate }}</span>
        <div fxFlex></div>
        <mat-icon svgIcon="ic-vault-shipment"></mat-icon>
      </div>
    </mat-radio-button>
  </mat-radio-group>

  <div
    *ngIf="shipmentForm.value.shipment == 3"
    class="warn pd-20"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <span>{{ "SEE_AGREEMENT_FOR_VAULT" | translate }}</span>
  </div>

  <div
    *ngIf="
      (checkoutService.selectedPaymentRequest | async)?.type ==
      'savingPlanProduct'
    "
    class=""
    fxLayout="column"
    fxLayoutGap="20px"
    fxLayoutAlign="start center"
  >
    <span>{{ "OR" | translate }}</span>
    <a (click)="sellFinishedSavingPlan()" class="pointer textColoredAccent"
      >{{ "GO_TO_PRODUCT_FOR_SELL" | translate }}
    </a>
  </div>

  <div fxFlex></div>

  <app-order-details-total
    [shippingPrice]="shippingPrice | async"
    [totalPrice]="totalPrice | async"
    [taxIncludes]="true"
    [formFee]="basketCost | async"
    [taxPrice]="basketTax | async"
    [showTaxPrice]="type == 'cart'"
    [showFormFee]="
      (checkoutService.selectedPaymentRequest | async)?.type == 'savingPlan'
    "
    [vaultSubsCost]="vaultSubsCost | async"
    [showDeliveryPrice]="!checkoutService.redirectToPaymentList.includes(type)"
    [showVaultSubsCost]="(checkoutService.selectedShipment) == 'VAULT'"
    fxFlexAlign="stretch"
  ></app-order-details-total>

  <button
    fxFlexAlign="center"
    mat-flat-button
    class="my-button"
    color="primary"
    type="submit"
  >
    {{ "CONTINUE" | translate }}
  </button>
</form>
